import { commonMapper } from '@bridebook/web/lib/track-utils/mappers/common-mapper';
import { ITrackingMapper } from '@bridebook/web/lib/track-utils/tracking-mappers';

export const budgetMapper: ITrackingMapper = (action, state) => {
  const [event, data] = commonMapper(action, state);
  return [event, { ...data, budget_target: action.payload }];
};
